<template>
    <!-- Quantity Input-->
    <div
        v-if="show()"
        class="product-qty intro-add-products flex flex-row w-full content-evenly items-center justify-center gap-x-2"
    >
        <label
            :for="wrapper+`-`+displayType+`-product-qty-`+productVariant.id"
            class="sr-only"
        >Quantity</label>

        <button
            class="shrink-0 intro-product-minus"
            :class="productVariantBasketQuantity > 0 ? 'cursor-pointer' : 'cursor-default'"
            :id="`gtm-cta-product-minus-`+productVariant.id"
            @click="basketRemoveQty"
        >
            <fa-icon
                icon="fa fa-minus"
                :class="{
                    'basket-red': productVariantBasketQuantity > 0,
                    'text-gray-200': ! productVariantBasketQuantity > 0
                }"
                :title="
                    productVariantBasketQuantity > 0
                        ? `Remove a ${ productVariant.title } from Basket`
                        : 'Nothing in basket to remove'
                "
            />
        </button>

        <input
            :data-variant_id="productVariant.id"
            :data-product_id="productVariant.product_id"
            :id="wrapper+`-`+displayType+`-product-qty-`+productVariant.id"
            class="text-xs sm:text-sm w-0 grow"
            min="0"
            max="3"
            type="number"
            @keypress="isNumber($event)"
            v-model.number="productVariantBasketQuantity"
        >

        <button

            class="shrink-0 intro-product-add"
                @click="basketAddQty"
            :id="`gtm-cta-product-add-`+productVariant.id"

        >
            <fa-icon
                icon="fa fa-plus"
                class="basket-green"
            />
        </button>
    </div>
</template>

<script>

import { debounce } from 'lodash'
import { mapState, mapActions } from 'pinia'
import { useBasketStore } from '@stores/Portal/basket/index.js'
import GtmEvent from "@modules/GtmEvent.js";

export default {
    name: "ProductQuantity",
    props: [
        'wrapper', // Needed for SEO / Tracking / unique input and labels in a recently viewed and you may also like exist on the same page.
        'productVariant',
        'displayType', // needed for unique id's as this is repeated on both desktop and mobile on basket item.
        'scale'
    ],
    mounted() {
        this.productVariantBasketQuantity = this
            .productVariant
            .basket_quantity ?? 0;

        // added variant local to avoid mutating prop directly after basket updated
        this.variantLocal = this.productVariant
    },
    watch: {
        productVariant() {
            this.productVariantBasketQuantity = this.productVariant.basket_quantity;
        },

        /**
         * Looks for the product variant qty chane and promos if it's 0 to remove the item.
         * Otherwise, will update the basket item and emit the update to the relevant components.
         *
         * @param newVal
         * @param oldVal
         */
        productVariantBasketQuantity(newVal, oldVal) {
            if ((newVal === 0 && oldVal !== 0 && this.counter === 0) || (newVal === '' && oldVal !== 0 && this.counter === 0)) {
                this.counter ++
                this.qtyChange(newVal);
                this.productVariantBasketQuantity = newVal;
                this.$emit('qtyChanged', this.productVariantBasketQuantity);
            } else {
                if (newVal !== '') {
                    this.qtyChange(newVal);
                }
            }
        }
    },
    methods: {
        ...mapActions(useBasketStore, ['setBasket']),

        /**
         * Hides if there is no price to stop any one from adding or modified qty's of promos or items with no price
         * Hides if the product is a BOTDEP as this is done automagically in the basket model.
         * @returns {boolean}
         */
        show() {
            return ! Boolean(
                this.productVariant.price === '0.00'
                || this.productVariant.price === null
                || this.productVariant.sku === 'BOTDEP'
            );
        },
        isNumber: function (evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
                //console.log(evt);
                this.$toast.open({
                    message: `<strong>"${evt.key}" is not a valid number</strong><br/>Please enter a number between 1 and 999`,
                    type: 'warning'
                });
            } else {
                return true;
            }
        },
        qtyChange: debounce(async function (quantity) {
            // If no change then do nothing.
            if (
                this.productVariantBasketQuantity > 0
                && this.productVariantBasketQuantity === this.productVariant.basket_quantity
                && this.first_request
            ) {
                return;
            }

            this.first_request = false;

            let URI = ``;
            let minQtyFlag = false;
            let qtyGroupFlag = false

            let gtmEvent = new GtmEvent({
                    eventName: this.variantLocal.basket_quantity <= quantity
                             ? "add_to_cart"
                             : "remove_from_cart",
                    items: this.variantLocal,
                    quantity: quantity - this.variantLocal.basket_quantity,
                    categoryListDetails: this.$page.props.currentCategory
                })
                .fireSelectPromotionEvent(this.variantLocal)
                .trackGtmEvent()

            if (quantity > 0) {
                // Check min quantity on items
                if (quantity < this.productVariant.qty_min) {
                    quantity = this.productVariant.qty_min;
                    minQtyFlag = true;
                }

                if (this.productVariant.qty_group_of) {
                    // check if qty is going up in multitudes of variant qty group step
                    let roundQty = this.roundQty(quantity, this.productVariant.qty_group_of)

                    if (roundQty !== quantity) {
                        quantity = roundQty
                        qtyGroupFlag = true;
                    }

                }

                URI = `/basket/${this.productVariant.id}/update`;
                this.apiConfig.method = 'POST';
                this.apiConfig.body = JSON.stringify({
                    'qty': quantity,
                    'cross_sell_area': gtmEvent.crossSellArea
                });

            } else {
                URI = `/basket/${this.productVariant.id}/delete`;
                this.apiConfig.method = 'GET';
                this.apiConfig.body = null;
            }

            if (this.abortController) {
                this.abortController.abort('Debounced')
            }

            let headers = {
                "X-CSRF-TOKEN": window.Laravel.csrf_token,
                Accept: "application/json",
            }

            if (
                Object(window.Laravel)
                    .hasOwnProperty('api_token')
            ) {
                headers['Authorization'] = `Bearer ${window.Laravel.api_token}`;
            }

            headers['Content-Type'] = 'application/json'

            this.abortController = new AbortController()

            fetch(URI, {
                ...this.apiConfig,
                signal: this.abortController.signal,
                headers
            })
                .then(response => {
                    if (response.ok) {
                        response.json().then(data => {
                            // Update the product card qty to what's in the basket.
                            this.productVariantBasketQuantity = data.item.basket_quantity;

                            // Update product variant if found in basket:
                            this.setBasket(data.basket)
                            this.variantLocal = data.item

                            let doToast = (
                                minQtyFlag
                                || qtyGroupFlag
                                || data.feedback
                            )

                            if (doToast) {
                                let toastType = false
                                let toastMessage = false

                                if (minQtyFlag || qtyGroupFlag) {
                                    // Alert user saying min quantity is set to qty_min on this product.
                                    toastMessage = `Quantity for '${this.productVariant.title}' must be ordered in multiples of ${this.productVariant.qty_group_of}`
                                    toastType = 'info'

                                    if (minQtyFlag) {
                                        toastMessage = `Minimum order quantity for '${this.productVariant.title}' is set to ${this.productVariant.qty_min}`
                                    }
                                }

                                this.$toast.open({
                                    message: toastMessage ? toastMessage : data.feedback.message,
                                    type: toastType ? toastType : data.feedback.type
                                });
                            }
                        })
                    } else {
                        if (response.status === 422) {
                            response.json().then(json => {
                                let errorMessage = "";
                                // Build up the error message from the errors array
                                for (let key in json.errors) {
                                    for (let key1 in json.errors[key]) {
                                        errorMessage += json.errors[key][key1];
                                    }
                                }
                                // Display toast error message
                                this.$toast.open({
                                    message: errorMessage,
                                    type: 'default',
                                    duration: 2000
                                });
                            })
                        } else {
                            this.$toast.open({
                                message: "<div class='v-toast__text'><h3>Sorry there was an error adding to the basket.</h3><pre>Status Code: " + response.status + "</pre><p>Please try again and contact Customer Services if you see this message again</p></div>",
                                type: 'error',
                                duration: 0
                            });
                        }
                    }
                })
        }, 0),

        roundQty(qty, qtyStep) {
            return Math.ceil((qty - qtyStep) / qtyStep ) * qtyStep + qtyStep;
        },

        // Basket Adding
        basketAddQty() {
            if (this.productVariantBasketQuantity === 0 && this.productVariant.qty_min) {

                // Alert user saying min quantity is set to qty_min on this product.
                this.$toast.open({
                    message: "Minimum order quantity for '" + this.productVariant.title + "' is set to " + this.productVariant.qty_min,
                    type: 'info',
                });
                this.productVariantBasketQuantity = this.productVariant.qty_min;

            } else if (this.productVariant.qty_group_of) {

                if (this.productVariantBasketQuantity === 0) {
                    // Alert user saying min quantity is set to qty_group_of on this product.
                    this.$toast.open({
                        message: "Quantity for '" + this.productVariant.title + "' must be ordered in multiples of " + this.productVariant.qty_group_of,
                        type: 'info',
                    });

                    this.productVariantBasketQuantity = this.productVariant.qty_group_of;

                }

                this.productVariantBasketQuantity = this.productVariantBasketQuantity + this.productVariant.qty_group_of;

            } else {
                this.productVariantBasketQuantity++;
            }

        },

        // Basket Removing
        basketRemoveQty() {
            if (this.productVariantBasketQuantity > 0) {
                // Check if it's the min qty value, and we are removing to set to zero.
                if (this.productVariant.qty_min && this.productVariantBasketQuantity == this.productVariant.qty_min) {
                    this.productVariantBasketQuantity = 0;
                } else if (this.productVariant.qty_group_of) {
                    this.productVariantBasketQuantity = this.productVariantBasketQuantity - this.productVariant.qty_group_of;
                } else {
                    this.productVariantBasketQuantity--;
                }
            }

        },

        scaleValue(type) {
            return (type === 'input' && this.scale < 1)
                 ? "transform:scale(" + (this.scale * 1.5) + ")"
                 : "transform:scale(" + this.scale + ")"
        },
    },
    computed: {
        ...mapState(useBasketStore, ['basket']),
    },
    data: () => ({
        first_request: true,
        abortController: null,
        apiConfig: {
            headers: {
                'Authorization': 'Bearer ' + window.Laravel.api_token,
                'Accept': 'application/json',
                'Content-Type': "application/json"
            }
        },
        productVariantBasketQuantity: 0,
        counter: 0,
        variantLocal: null
    }),
}
</script>

<style scoped>

.product-basket-btn {
    @apply w-8 h-8 rounded-full flex justify-center items-center rounded-full cursor-pointer transition duration-300 ease-in-out text-gray-400  border-2 border-solid border-gray-200 bg-white bg-opacity-40
}


.basket-red {
    @apply hover:text-red-300
}

.basket-green {
    @apply hover:text-green-300
}

.product-qty button {
    @apply w-10 h-10 rounded-full flex justify-center items-center rounded-full cursor-pointer transition duration-300 ease-in-out text-gray-400  border-2 border-solid hover:border-solid hover:border-gray-300 border-gray-200 bg-white bg-opacity-40;
}

.product-qty button i {
    @apply transition duration-300 ease-in-out;
}

.product-qty input {
    @apply min-w-[88px] text-black-500 font-bold rounded-lg border-2 border-solid focus:border-solid focus:border-solid focus:border-gray-300 border-gray-200  text-center focus:ring-0 focus:border-gray-200 bg-white;
    background: none;
    max-width: 138px;
}


.product-qty input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    @apply focus:outline-none
}

.product-qty input[type=number] {
    -moz-appearance: textfield;
    @apply focus:outline-none
}

</style>
